import './style.scss'

export default {
  name:'Spin',
  props:['loading'],
  render(){
    const { loading , $scopedSlots } = this
    const loadingNode = loading ? <div class="sl-spin-spinning">
          <i class="sl-spin-dot">
            <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
          </i>
        </div> : null
    const contentNode = $scopedSlots.default ? <div class={['sl-spin-container' , loading ? 'sl-spin-blur' : null]}>
          { $scopedSlots.default()}
      </div> : null

    return (
      <div class="sl-spin">
        {loadingNode}
        {contentNode}
      </div>
    )
  }
}

/*
export default {
  name:'Spin',
  props:['loading'],
  render(){
    const { loading } = this
    if( loading ){
      return <div style="width:100%;height:100%;position:relative;">
        <div class="sl-spin">
          <i class="sl-spin-dot">
            <svg viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path"></circle></svg>
          </i>
        </div>
      </div>
    }else{
      return this.$scopedSlots.default && this.$scopedSlots.default()
    }
  }
}
*/